const css = () => {
  throw new Error('Using the "css" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly.');
};

export default css;
//# sourceMappingURL=css.js.map